module.exports = __webpack_public_path__ + "static/media/branches.19a4b14e.svg";